(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/backgrounds/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tur/backgrounds/assets/prescript.js');
"use strict";


svs.components = svs.components || {};
svs.components.tur = svs.components.tur || {};
svs.components.tur.backgrounds = svs.components.tur.backgrounds || {};

 })(window);